// auth.interceptor.ts
// Last modified: 2026-08-22
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  
  if (token && req.url.includes(environment.apiBaseUrl)) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
  }
  
  // Public auth endpoints that should not trigger a logout on 401
  const publicPaths = [
    '/signup',
    '/login',
    '/token',
    '/org-lookup',
    '/verify-email',
    '/resend-verification',
    '/google/nonce',
    '/google-signin',
    '/google-signup'
  ];
  const isPublicAuth = publicPaths.some(p => req.url.includes(p));

  return next(req).pipe(
    catchError(error => {
      if (error.status === 401 && !isPublicAuth) {
        // Reset auth service and redirect to login
        authService.logout();
      }
      return throwError(() => error);
    })
  );
};